import Moment from 'moment';

export const formatDateTime = (datetimeValue) => {
        Moment.locale('en');
        return Moment(datetimeValue).format('DD/MM/yyyy');
}

export * from './Text';